import { useAuth0 } from "@auth0/auth0-react";
import InputNoError from "../UI/InputNoError";
const labelStyle = { width: "10.5%", fontSize: "14px" ,padding:"5px"};
const dateLabelStyle = { width: "3%", fontSize: "16px", paddingLeft: "5px" };
const inputCellStyle = { width: "32%", fontSize: "14px", height: "20px" };
const infoTextStyle = { background: "white", fontSize: "12px", padding: "0px" };

const RoomRow = ({
  label,
  roomValue,
  slotText,
  risCode,
  appointmentLength,
  datePicker,
  onChangeField,
  inputChangedHandler,
  orderObj
}) => {
  const { user } = useAuth0();
 return  <tr >
  
    <td style={labelStyle}  title="Room Name">
      {label}
    </td>

    <td style={inputCellStyle}>
      <InputNoError
        id={onChangeField}
        name={onChangeField}
        width="100%"
        placeholder="Room Name"
        Value={roomValue}
        disabled={
          user?.oi_profile?.toLowerCase() === "customer" &&
          orderObj?.Operator_Feedback?.operator_feedback === "1001"
        }
        onChange={(event) => inputChangedHandler(event, onChangeField)}
        customStyle={{
          textTransform: "uppercase",
          marginRight: "5px",
        }}
      />
    </td>

    <td style={{ width: "100px"}}>
      <span title="COMRAD Reserve" style={{...infoTextStyle,marginLeft:"10px"}}>
        Res: {slotText}
      </span>

      {risCode && (
        <span
          title="RIS Service Code"
          style={{ ...infoTextStyle, display: "block"}}
        >
          RSC: {risCode}
        </span>
      )}
          <td>
      {appointmentLength && (
        <span style={{ color: "red", fontSize: "14px",marginLeft:"10px"}}>
          {appointmentLength} min
        </span>
      )}
    </td>
    </td>


    <td style={dateLabelStyle} title="Appointment Date">
     <div style={{paddingRight:"5px"}}>A.D:</div> 
    </td>

    <td>
      <div>{datePicker()}</div>
    </td>
  </tr>;
};

export default RoomRow;